import axios from 'axios';

// Create axios instance for auth endpoints
const authAPI = axios.create({
  baseURL: '/api/v1/auth',
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: true // Important for cookies
});

// Attach CSRF header to all auth requests (except /login which doesn't need it initially)
authAPI.interceptors.request.use((config) => {
  // Skip CSRF for /login endpoint (first login won't have CSRF token yet)
  if (config.url && config.url.includes('/login')) {
    return config;
  }

  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    const [name, value] = cookie.trim().split('=');
    if (name === 'csrf' || name === '__Host-csrf') {
      config.headers['X-CSRF-Token'] = value;
      break;
    }
  }
  return config;
});


// Helper function to get CSRF token from cookie
const getCSRFToken = () => {
  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    const [name, value] = cookie.trim().split('=');
    if (name === 'csrf' || name === '__Host-csrf') {
      return value;
    }
  }
  return null;
};

// Helper function to get refresh token from cookie
const getRefreshToken = () => {
  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    const [name, value] = cookie.trim().split('=');
    if (name === 'refresh') {
      return value;
    }
  }
  return null;
};

// Helper function to check if user has any auth cookies
export const hasAuthCookies = () => {
  // Check for refresh token as indicator of active session (lives 90 days)
  // CSRF token expires after 60 min, so we can't rely on it
  return getRefreshToken() !== null;
};



// Login function using /login endpoint
export const login = async (email, password) => {
  try {
    // Call /login to set HttpOnly cookies (access, refresh, csrf)
    const response = await authAPI.post('/login', {
      email: email,
      password: password
    });


    return response.data;
  } catch (error) {
    console.error('Login error:', error.response?.data?.detail || error.message);
    throw error;
  }
};

// Logout function
export const logout = async () => {
  try {
    const csrfToken = getCSRFToken();
    const headers = {};
    if (csrfToken) {
      headers['X-CSRF-Token'] = csrfToken;
    }


    await authAPI.post('/logout', {}, { headers });

  } catch (error) {
    // Continue with local logout even if API call fails
    console.warn('Logout API call failed:', error);
  }
};

// Refresh token function
export const refreshToken = async () => {
  const csrfToken = getCSRFToken();
  const headers = {};
  if (csrfToken) {
    headers['X-CSRF-Token'] = csrfToken;
  }

  const response = await authAPI.post('/refresh', {}, { headers });
  return response.data;
};

// Get current user info
export const getCurrentUser = async () => {
  const response = await authAPI.get('/me')
  return response.data;
};


